import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';

import CountdownTimer from '../CountdownTimer';

function Overview() {
    return (
        <div className="white-bg" style={{ padding: "20px" }}>

            <h2 class='text-center mb-3'>7th Convocation - Updates</h2>  


            <Row className='mx-3 mt-5 text-center'>
                <Col xs={12} md={6} className="mb-3 order-md-2">
                    <Button className='btn-lg c-fontsize14'>
                        <i className="fab fa-youtube me-2"></i>
                        <a href="https://www.youtube.com/watch?v=qN3XWGwtcpI" target='_blank' className='text-white'  >
                            Watch on Youtube </a></Button>
                </Col>
                <Col xs={12} md={6} className="mb-3 order-md-1">
                    <Button className='btn-lg c-fontsize14' >
                    <i className="far fa-file-pdf me-2"></i>
                        <a href="https://files.iittp.ac.in/pdfs/convocation/2025/IITTP_Convocation_Brochure_2025.pdf" target='_blank' className='text-white'  >
                            7th Convocation Brochure</a></Button>
                </Col> 
            </Row>

 

            <ul className='myulcustarrow c-lineheight2dot5 m-2'>

                {/* <li><Link to="#" target="_self"> Click here to view Convocation Brochure - July 2024 - <span className="glowing-text"><b>Will be updated soon..</b></span></Link></li> */}
                {/* <li><Link to="https://www.iittp.ac.in/convocation2024/" target="_blank"> For more Details</Link></li> */}
                <li>The 7th Convocation of IIT Tirupati is scheduled on <b style={{ color: "blue" }}>20th July 2025 (Sunday) from 3:30 pm to 5:30 pm</b>. The Chief Guest for the convocation is <b style={{ color: "maroon" }}>Shri Lakshmi Narayanan, Co-Founder, Cognizant; Chancellor, Krea University</b>. Our Chairman, Board of Governors, <b style={{ color: "maroon" }}>Shri Sajjan Jindal (Chairman & Managing Director, JSW Group)</b> will preside over the ceremony.</li>
                <li>The graduates should report to the institute on <b>19th July, 2025</b>. The convocation kits will be issued from <b>10 am on 19th July</b> and must be collected before <b>10 am on 20th July</b>.</li>
                <li>The Convocation rehearsals will be done on the <b>19th afternoon</b> and also on the <b>20th morning</b> and it is mandatory for all the graduates to attend both the convocation rehearsals. Followed by Convocation rehearsals on the <b>19th afternoon</b> interaction with faculty with High-Tea is arranged.</li>
                <li><b>Google form link for registration for 7th Convocation</b> must be filled before <b>July 07, 2025, noon, </b> by all graduating students :<Link to="https://forms.gle/GffWyUkSKcAnNsPE6" target="_blank" className="glowing-text"><b style={{ color: "blue" }}><u>Registration Link </u></b></Link></li>
            </ul>

            
            {/* <p className="caboutus"> An informal interactive session <b>“Meet your teachers” is arranged on 20th July 2024 at 5 pm</b> in the lobby of LHC along with High-tea. This will be a unique opportunity to interact with the faculty.  </p> */}
            
        </div>
    );
}

export default Overview;
